<div class="tab-pane show active fade details-view-results support-information" id="trial-links" role="tabpanel">
  <!-- Start: Support Information -->
  <div>
    <div class="title-culture-select">
      <h2>Support Information</h2>

      <div class="title-culture-select-right-side">
        <div class="culture-select">
          <app-input-select #cultureSelect [items]="supportInfoFilteredCultures" [parentForm]="supportForm" controlName="selectedCulture" [allowFiltering]="true" [allowClear]="false" (onFilter)="onSupportInfoCultureFiltered($event)" searchInputPlaceholder="Search..."></app-input-select>
        </div>

        <app-button variant="primary" text="Save" [disabled]="!hasChanges" (clicked)="saveSupportInfo()" />
      </div>
    </div>
  </div>
  <!-- End: Support Information -->

  <!-- Start: Support Info Forms -->
  <div>
    @for (form of infoForms; track form) {
      <form [formGroup]="form" [class.visibility-hidden]="form.value.culture !== supportForm.value.selectedCulture">
        <div class="form-group">
          <label>Support Text</label>
          <app-editor formControlName="text"></app-editor>
        </div>

          <div class="form-group">
              <label>Global Link Text</label>
            <app-editor formControlName="globalLinkSupportText"></app-editor>
          </div>

          <div class="form-group">
              <label>Country Specific Link Text</label>
            <app-editor formControlName="countryLinkSupportText"></app-editor>
          </div>
      </form>
    }
  </div>
  <!-- End: Support Info Forms -->
</div>
